import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import ShopListRow from '../shop_list/shop_list_row';
import {observer, inject} from 'mobx-react';

@inject('RootStore')
@observer
export default class ShopListWidgetWide extends Component {
    render() {
        let shopList = [];
        for(let i = 0; i < this.props.RootStore.hallStore.shopsList.length-1; i=i+2) {
            shopList.push(<Flexbox height="2%"  flexGrow={1} key={i}></Flexbox>);
            shopList.push(<Flexbox height="15%"><ShopListRow shop1={this.props.RootStore.hallStore.shopsList[i]} shop2={this.props.RootStore.hallStore.shopsList[i+1]} key={i + this.props.RootStore.hallStore.shopsList.length + 2}/></Flexbox>)
        }
        if(this.props.RootStore.hallStore.shopsList.length % 2 !== 0) {
            shopList.push(<Flexbox key={this.props.RootStore.hallStore.shopsList.length * 2 + 5} height="2%"  flexGrow={1}></Flexbox>);
            shopList.push(<Flexbox height="15%"><ShopListRow wide='True' shop1={this.props.RootStore.hallStore.shopsList[this.props.RootStore.hallStore.shopsList.length-1]} key={this.props.RootStore.hallStore.shopsList.length * 2 + 6}/></Flexbox>)
        }
        shopList.push(<Flexbox height="2%"  flexGrow={1} key={this.props.RootStore.hallStore.shopsList.length * 2 + 7}></Flexbox>);
        return (
            <Flexbox height="100%" width="100%" flexDirection="column" style={{fontSize: "2.1vh"}}>
                {shopList}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_widget_wide.jsx